module.exports = __webpack_public_path__ + "static/media/balance_3000000_5000000.525da0b4.png";